export default __webpack_public_path__ + "images/20210706_OfficeofSAI_StudentGovernmentLogo_001f86bb8ca-b6bd-4fb1-850b-88275f541424.png";